module.exports = __webpack_public_path__ + "resources/img/img_dvision1_m_en.5a6da69c713b2ac9dcdcbd0aa1d11d4d.png";